import React, {useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import fixelLogo from "../../img/Fixel_Logo2019vector1.svg";
import Spinner from "../utils/LoadingSpinner";
import { StyledMainContainer, StyledHeader, StyledIFrame, StyledButton, StyledForm } from "./intro.style";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "../../services/firebase";
import {creatCustomer, formDataWithToken, getHostname, wpUrl} from "../../services/globalService";
import {useCustomer} from "../../provider/customerProvider";
import {sendNewSegmentToAnalytics} from "../../services/analytics";

const Introduction = () => {
  const history = useHistory();
  const [user, loading] = useAuthState(Firebase.auth);
  const [showSpinner, setShowSpinner] = useState(true);
  const {customer, setCustomer} = useCustomer();


  useEffect(()=> {
    if(!loading) {
      setShowSpinner(false)
    }
  },[loading]);

  /**
   *  run on install sucess callback
   */
  const onInstallSuccess = () => {
    if(process.env.NODE_ENV !== 'production') {
      console.log("%cinstall success", "color:#7ed07e");
    }
    history.push('/setup');
  }

  const doInstall = async () => {

    // Facebook and Google pixels
    sendNewSegmentToAnalytics();

    // create trial
    const trialPlanObj = {
      action: 'fxl_create_plan',
      display: getHostname(window.location.hostname),
      email: user.email
    }

    const trial_plan = await formDataWithToken(wpUrl,trialPlanObj);

    if(trial_plan?.data?.success) {
      const installObj = {
        customer: JSON.stringify(user),
        action: 'fxl_create_segment',
        displayName: getHostname(window.location.hostname),
        plan_id: JSON.parse(trial_plan.data.data).plan_id
      }
      return formDataWithToken(wpUrl, installObj);
    }
  }

  const installFixel = async (e) => {
    e.preventDefault();
    try {
      if(customer) {
        setShowSpinner(true);
        const result = await doInstall();
        if(result?.data){
          onInstallSuccess();
        }else {
          if(process.env.NODE_ENV !== 'production') {
            console.error('failed install');
          }
        }
        setShowSpinner(false);
      }else{
        if(process.env.NODE_ENV !== 'production') {
          console.err('Function: installFixel, Line 65 (Customer does not exist): ', customer);
        }

        const res = await creatCustomer(user);
        if (res) {// validate res
          setCustomer(user);
          const installFixelRes = await doInstall();
          if(installFixelRes?.data){
            onInstallSuccess();
          }
        }
      }

    } catch (error) {
      console.error('Function: installFixel, Line 61 (): ', error);
    }
  };

  // cleanup spinner after component unmount
  useEffect(() => {
    return () => setShowSpinner(false);
  }, []);

  return (
    <StyledMainContainer>
      <StyledHeader>
        <img src={fixelLogo} alt="fixel logo" />
        <h1>Hello {user ? user.displayName : ''}</h1>
        <h3>Welcome to Fixel</h3>
        <p>Learn how to get powerful AI-Segmented Audiences Across Ad Platforms</p>
      </StyledHeader>

      <StyledIFrame title="Fixel introduction video" width="470" height="269" src="https://www.youtube.com/embed/UkioxVbrDNA?modestbranding=1&rel=0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></StyledIFrame>

      {user && <StyledForm onSubmit={installFixel}>

        {showSpinner ? (
          <Spinner />
        ) : (
          <StyledButton type="submit">Install Fixel</StyledButton>
        )}
      </StyledForm>}
    </StyledMainContainer>
  );
};
export default Introduction;
